
import React from "react";
import '../styles/WebCampaignInfoScreen.css';

// @ts-check


/**
 * @param {{title: string, info: string, image: string, mirrored: ?boolean, narrow: ?boolean }} props 
 * @returns {JSX.Element | null}
 */
function WebCampaignInfoScreen(props) {
    
  const titleP = (<h1 className="web-campaign-info__title__text">{props.title}</h1>);

  if (props.mirrored) {

    return (
        <div className="web-campaign-info__container">
            <div className="web-campaign-info__container__right">
                <img className="web-campaign-info__image" src={props.image} alt=""/>
            </div>
            <div className="web-campaign-info__container__left">
                { (props.narrow)
                   ? <div className="web-campaign-info__title__view--narrow">{titleP}</div>
                   : <div className="web-campaign-info__title__view">{titleP}</div>}
                <p className="web-campaign-info__info">{props.info}</p>
            </div>
        </div>);
  }
  else {
    return (
        <div className="web-campaign-info__container">
            <div className="web-campaign-info__container__left">
            { (props.narrow)
                   ? <div className="web-campaign-info__title__view--narrow">{titleP}</div>
                   : <div className="web-campaign-info__title__view">{titleP}</div>}
                <p className="web-campaign-info__info">{props.info}</p>
            </div>
            <div className="web-campaign-info__container__right">
                <img className="web-campaign-info__image" src={props.image} alt=""/>
            </div>
        </div>);
  }
}

export default WebCampaignInfoScreen;